<style>
    #main {
        position: relative;
        height: 100vh;
        background-color: #fafbfd;
    }

    #main .inner {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .inner {
        max-width: 520px;
        width: 100%;
        text-align: center;
    }

    .inner .bg {
        position: absolute;
        left: 0px;
        right: 0px;
        top: 50%;
        z-index: -1;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .inner .bg>div {
        width: 100%;
        background: #fff;
        border-radius: 90px;
        height: 125px;
        -webkit-box-shadow: 5px 5px 0px 0px #f3f3f3;
        box-shadow: 5px 5px 0px 0px #f3f3f3;
    }

    #second {
        -webkit-transform: scale(1.3);
        -ms-transform: scale(1.3);
        transform: scale(1.3);
        position: relative;
        z-index: 10;
    }

    #third {
        position: relative;
        z-index: 100;
    }

    h1 {
        font-family: 'Quicksand', sans-serif;
        font-size: 86px;
        text-transform: uppercase;
        font-weight: 700;
        margin-top: 0;
        margin-bottom: 8px;
        color: #151515;
    }

    h2 {
        font-family: 'Quicksand', sans-serif;
        font-size: 26px;
        margin: 0;
        font-weight: 700;
        color: #151515;
    }

    button {
        margin-top: 15px;
    }

    @media only screen and (max-width: 767px) {
        .inner .bg {
            width: 287px;
            margin: auto;
        }

        .inner .bg>div {
            height: 85px;
        }

        h1 {
            font-size: 58px;
        }

        h2 {
            font-size: 16px;
        }
    }

    @media only screen and (max-width: 480px) {
        h1 {
            font-size: 48px;
        }

        h2 {
            font-size: 14px;
        }
    }
</style>

<div id="main">
    <div class="inner">
        <div class="bg">
            <div id="first"></div>
            <diV id="second"></diV>
            <div id="third"></div>
        </div>
        <h1>Sorry!</h1>
        <h2>404 : Page Not Found</h2>
        <button type="button" class="btn btn-primary btn-lg" (click)="goBack()">Go back</button>
    </div>
</div>